// extracted by mini-css-extract-plugin
module.exports = {"BlinkImage":"Spinner_BlinkImage__32m40","blink":"Spinner_blink__1Akjk","SpinnerContainer":"Spinner_SpinnerContainer__2nTcD"};